import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConnectorAvatar } from '#pplx/frontend/apps/ask/connectors/components/ConnectorAvatar.js';
import { createStackedVisuals } from '#pplx/frontend/apps/ask/shared-ui-components/createStackedVisuals.js';
import { FormattedMessage } from 'react-intl';
const PLUGIN_CONNECTOR_VISUAL_LIMIT = 3;
/** The line under a plugin title in the detail panel: connector logos and count, then skill count. */
export const PluginSourceLabel = ({ plugin }) => {
    const { connectors, skills } = plugin;
    const skillCount = skills.length;
    const skillsLabel = (_jsx(FormattedMessage, { defaultMessage: "{count, plural, one {# skill} other {# skills}}", description: "Label shown under a plugin title with the number of skills it bundles", id: "fa4167bfe5", values: { count: skillCount } }));
    if (connectors.length === 0)
        return skillsLabel;
    // Plugins only declare DDB-backed sources, so the resolver's icon_url is the only logo source.
    const logos = createStackedVisuals(connectors.map((connector) => (_jsx(ConnectorAvatar, { connectorAvatar: connector.icon_url ?? null, name: connector.display_name, size: "tiny" }, connector.source_id))), {
        isOverlapping: true,
        maxVisuals: PLUGIN_CONNECTOR_VISUAL_LIMIT,
        size: 'xs',
        shape: 'squircle',
        stackDirection: 'right',
        showRemainderCount: false,
        containerClass: 'flex items-center',
    });
    const connectorsLabel = (_jsxs("span", { className: "inline-flex items-center gap-1 align-bottom", children: [logos, _jsx(FormattedMessage, { defaultMessage: "{count, plural, one {# connector} other {# connectors}}", description: "Number of connectors bundled in a plugin on its marketplace card", id: "25a5093dc4", values: { count: connectors.length } })] }));
    if (skillCount === 0)
        return connectorsLabel;
    // Two plurals cannot share one message (formatjs/no-multiple-plurals), so this joins the
    // two count messages with the same separator message the marketplace card footer uses.
    return (_jsx(FormattedMessage, { defaultMessage: "{connectors} \u00B7 {skills}", description: "Separate connector and skill count labels in a plugin card footer", id: "5c1e4b1004", values: { connectors: connectorsLabel, skills: skillsLabel } }));
};
//# sourceMappingURL=PluginSourceLabel.js.map